// loop through el parents to find the one with `attributeName` attribute
export const getParentByAttribute = (el, attributeName) => {
  let loopLimit = 0;
  while (loopLimit < 20) {
    if (!el) {
      return null;
    }

    if (el.classList && el.classList.contains('ProseMirror')) {
      return null;
    }

    if (el.getAttribute(attributeName)) {
      return el;
    }

    // eslint-disable-next-line no-param-reassign
    el = el.parentNode;
    loopLimit += 1;
  }
  return null;
};
